// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2mO56","buttons":"SendReceipts_buttons__2DpKK","email":"SendReceipts_email__2jSf_","bookApptTitle":"SendReceipts_bookApptTitle__3y3Yr"};